import ResumenEncuesta from "pages/LandingPages/ResumenEncuesta/resumenEncuesta";

export default function ResumenEncuestaPage() {
  return <ResumenEncuesta />;
}
